import {Platform} from 'react-native';
import {getMobileAuth0Client} from '../../nativeModules/Auth0';
import {authStore} from 'src/init';

/**
 * tryRecoverSession
 * -----------------
 * Runs once at cold-start (and optionally on each resume) **before**
 * any API traffic.  It guarantees one of two outcomes:
 *
 *   • a fresh, valid access-token is stored in CredentialsManager, or
 *   • it calls the `goToLogin()` callback so the app shows the Login UI
 *     instead of firing a 401-causing API call.
 *
 * Steps:
 *   1)  Quick check – is a non-expired token already in Keychain?
 *   2)  If expired, use the ROTATING refresh-token to get a new pair.
 *   3)  (Android only) final fallback: silent SSO using the Auth0 cookie
 *       in a Chrome Custom-Tab (`prompt=none`).  iOS is skipped to avoid
 *       the system consent alert.
 *   4)  If everything fails, invoke `goToLogin()`.
 */
export async function tryRecoverSession(goToLogin: () => void): Promise<void> {
  if (Platform.OS === 'web') {
    return;
  }

  const auth0 = getMobileAuth0Client();

  try {
    if (await auth0.credentialsManager.hasValidCredentials()) {
      return;
    }

    const refreshToken = await authStore.getRefreshToken();
    if (refreshToken) {
      const creds = await auth0.auth.refreshToken({refreshToken});
      await auth0.credentialsManager.saveCredentials(creds);
      return;
    }

    if (Platform.OS !== 'ios') {
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        await auth0.webAuth.authorize({
          scope: 'openid profile email offline_access',
          additionalParameters: {prompt: 'none'},
        });
        return;
      } catch (authError) {

      }
    }
  } catch (e) {

  }

  goToLogin();
}
